import { qbHttp } from "./http";

export const listSettings = () => qbHttp.request("api/qb/settings");

export const getSetting = (key) =>
  qbHttp.request(`api/qb/settings/${encodeURIComponent(key)}`);

export const updateSetting = (key, body) =>
  qbHttp.request(`api/qb/settings/${encodeURIComponent(key)}`, { method: "PUT", body });
